<template>
  <div>
    <template v-if="loading">
      <div class="d-flex flex-column justify-center align-center" style="height: calc(100vh - 128px)">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <div>
        <v-responsive class="mt-4 mx-4" :aspect-ratio="1.618">
          <v-carousel
            class="rounded-xl"
            :show-arrows="false"
            cycle
            delimiter-icon="mdi-circle-small"
            height="100%"
            hide-delimiter-background
          >
            <v-carousel-item
              v-for="(image) in imageList"
              :key="image.id"
            >
              <v-img :aspect-ratio="1.618" :src="GlobalConfig.imageRoot+image.image"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-responsive>
      </div>
      <template v-if="!fastFoodMode">
        <div class="mt-n4 mx-6">

          <v-card
            v-if="!tableUsing" class="pa-2" flat style="border-radius: 12px;display: grid;
      grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px"
          >
            <div
              class="d-flex pa-4 flex-column justify-center align-center"
              @click="shouldOpenTable(false)"
            >
              <div
                class="text-h6 text-truncate font-weight-black amber--text text--lighten-4" style="max-width: 145px;"
              >
                {{ $t("ScanCodeDineIn") }}

              </div>
              <div class="text-body-2 text-truncate text--secondary" style="max-width: 110px;">
                {{ $t("DeliciousFoodGlance") }}
              </div>
              <v-img class="mt-3" contain src="img/homePage/restaurant.svg" width="64" />
            </div>
            <div
              class="d-flex pa-4 flex-column justify-center align-center"
              @click="shouldOpenTable(true)"
            >
              <div
                class="text-h6 text-truncate font-weight-black amber--text text--lighten-4" style="max-width: 145px;"
              >
                {{ $t("PickAndTakeAway") }}
              </div>
              <div class="text-body-2 text-truncate text--secondary" style="max-width: 110px;">
                {{ $t("AdditionalDiscount") }}
              </div>
              <v-img class="mt-3" contain src="img/homePage/shopping-bag.svg" width="64" />
            </div>
          </v-card>
          <v-card v-else class="pa-4 py-6 d-flex align-center" flat style="border-radius: 12px">
            <v-avatar size="36">
              <v-img src="img/homePage/restaurant.svg"></v-img>
            </v-avatar>
            <div class="d-block overflow-hidden ml-4">
              <div class="text-body-1 font-weight-black">
                {{ $t("CurrentTableNumber") }}{{ currentOrderInfo.name }}
              </div>
              <div
                class="text-truncate text-caption text--secondary"
              >
                {{ $t("ContinueEnjoyFood") }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="primary black--text" @click="$router.push('/menu')">{{ $t("Go") }}</v-btn>
          </v-card>
          <v-card v-if="isLogin" class="mt-4 pa-4 px-4 d-flex align-center" flat style="border-radius: 12px">
            <v-avatar size="36">
              <v-img src="img/homePage/woman.svg"></v-img>
            </v-avatar>
            <div class="d-block overflow-hidden ml-4 mr-2">
              <div class="text-body-1 font-weight-black">
                {{ $t("MyNotes") }} {{ 0 }}
              </div>
              <div
                class="text-truncate text-caption text--secondary"
              >
                {{ $t("RedeemableCouponsLimitedMerchandise") }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="mr-4 d-flex flex-column align-center justify-center" @click="showUserCode=true">
              <v-icon size="36">mdi-qrcode</v-icon>
            </div>
          </v-card>
          <v-card v-else class="mt-6 pa-4 px-4 d-flex align-center" flat style="border-radius: 12px">
            <v-avatar size="36">
              <v-img src="img/homePage/woman.svg"></v-img>
            </v-avatar>
            <div class="d-block overflow-hidden ml-4 mr-1">
              <div class="text-body-2 font-weight-black">
                {{ $t("WelcomeLoginBecomeMember") }}
              </div>
              <div
                class="text-truncate text-caption text--secondary"
              >
                {{ $t("EnjoyPointsAndBenefits") }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="primary black--text" small text @click="startLogin">{{ $t("LoginNow") }}</v-btn>
          </v-card>
          <div class="mt-6">
            <v-card class="pa-4 d-flex align-center" flat style="border-radius: 12px" @click="displayComingPage">
              <v-img class="flex-grow-0" src="img/homePage/voucher.svg" width="36"></v-img>
              <div class="d-block overflow-hidden">
                <div class="text-truncate text-body-2 ml-4 text-capitalize">{{ $t("Coupon") }}</div>
              </div>
            </v-card>
            <v-card class="pa-4 mt-4 d-flex align-center" flat style="border-radius: 12px" @click="displayComingPage">
              <v-img class="flex-grow-0" src="img/homePage/profits.svg" width="36"></v-img>
              <div class="d-block overflow-hidden">
                <div class="text-truncate text-body-2 ml-4 text-capitalize">{{ $t("RechargeCredit") }}</div>
              </div>
            </v-card>
          </div>
        </div>
      </template>
      <template v-else>
        <v-card
          color="transparent"
          class="pa-4" style="position: fixed;bottom: 0;left: 0;right: 0;border-radius: 0 0 12px 12px"
        >
          <div class="text-body-1 mb-2">
            {{ $t('HowWouldULikeToEat') }}
          </div>
          <div
            v-if="!tableUsing" class="pa-2" flat style="border-radius: 12px;display: grid;
      grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px"
          >
            <v-card
              rounded="xl"
              class="d-flex pa-4 justify-center align-center"
              @click="shouldOpenTable(false)"
            >
              <v-avatar class="mr-3" size="36">
                <v-img contain src="img/homePage/restaurant.svg" />
              </v-avatar>
              <div>
                <div
                  class="text-body-1
                   text-truncate
                   font-weight-black
                   text-no-wrap
                   amber--text text--lighten-4"
                >
                  {{ $t("ScanCodeDineIn") }}
                </div>
              </div>


            </v-card>
            <v-card
              rounded="xl"
              class="d-flex pa-4 justify-center align-center"
              @click="shouldOpenTable(true)"
            >
              <v-avatar class="mr-3" size="36">
                <v-img contain src="img/homePage/shopping-bag.svg" />
              </v-avatar>

              <div>
                <div
                  class="text-body-1 text-truncate font-weight-black amber--text text--lighten-4 text-no-wrap"
                >
                  {{ $t("PickAndTakeAway") }}
                </div>
              </div>


            </v-card>
          </div>
        </v-card>


      </template>

    </template>


    <v-bottom-sheet v-model="showUserCode">
      <user-code-page />
    </v-bottom-sheet>

  </div>
</template>

<script>

import { getOrderStatus, getRestaurantInfo, getTableInfo } from "@/dataLayer/service/api";
import { mapState } from "vuex";
import UserCodePage from "@/views/pages/UserCodePage.vue";
import { getBannerImageList } from "@/dataLayer/repository/restaurantInfo";
import { GlobalConfig, isFastFoodMode, setTableName } from "@/dataLayer/repository/GlobalSettingManager";
import dayjs from "dayjs";
import router from "@/plugins/router";
import { Remember } from "@/plugins/firebase";
import { openOrEnterTable } from "@/dataLayer/repository/TableManage";

export default {
  name: "IndexPage",
  components: { UserCodePage },
  data: function() {
    return {
      fastFoodMode: isFastFoodMode(),
      showHotPotOpenTablePage: false,
      loggedIn: false,
      currentOrderInfo: null,
      showUserCode: false,
      showScanQrCodeDialog: null,
      scanResult: "",
      scanHasError: false,
      GlobalConfig,
      loading: true,
      imageList: []
    };
  },
  computed: {
    ...mapState(["isLogin", "userInfo"]),
    tableUsing() {
      return this.currentOrderInfo?.usageStatus === "1";
    }
  },
  async mounted() {
    await this.reload();
  },
  destroyed() {
    clearInterval(this.handel);
  },
  methods: {
    async reload() {
      this.loading = true;
      if (this.fastFoodMode) {
        const orderInfo = await getOrderStatus();
        if (orderInfo?.billInfo && orderInfo?.billInfo?.consumeTypeStatusId < 5) {
          setTableName(orderInfo?.billInfo?.tableName);
          router.replace("/menu");
        } else {
          Remember.orderId = "";
        }
        console.log(orderInfo);
      } else {
        this.currentOrderInfo = (await getTableInfo());
      }


      this.imageList = await getBannerImageList();
      this.GlobalConfig = GlobalConfig;
      await this.openAnnouncement();
      this.loading = false;
    },
    hashcode(code) {
      let hash = 0, i, chr, len;
      if (code.length === 0) return hash;
      for (i = 0, len = code.length; i < len; i++) {
        chr = code.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
      }
      return hash;
    },
    async openAnnouncement() {
      const res = await getRestaurantInfo();
      const today = dayjs().format("YYYY-MM-DD");
      const announce = this.hashcode(res.buffetAnnouncementBody).toString();
      const oldDate = localStorage.getItem("date");
      const oldAnnounce = localStorage.getItem("announce");
      const timespan = dayjs(today).diff(oldDate, "day");
      if (!oldDate || timespan > 7) {
        localStorage.setItem("date", today);
        this.$store.commit("showAnnouncement", true);
      }
      if (oldAnnounce && oldAnnounce === announce) {
        return;
      }
      localStorage.setItem("announce", announce);
      this.$store.commit("showAnnouncement", true);
    },
    displayComingPage() {
      this.$store.commit("showComingPage", true);
    },
    startLogin() {
      this.$store.commit("showLoginPage", true);
    },
    async shouldOpenTable(isTakeaway = false) {
      if (this.fastFoodMode) {
        Remember.modeSelected = 1;
        Remember.takeawayMode = isTakeaway ? 1 : 0;
        Remember.sessionId = dayjs().valueOf().toString();
        router.replace("/menu");
      } else {
        openOrEnterTable(isTakeaway);
      }

    }

  }
};
</script>

<style scoped>

</style>
